import React from 'react';
import Settings from '../../../pages/Settings';

const AISettings: React.FC = () => {
  return <Settings />;
};

export default AISettings;